import DetailsMenu from './DetailsMenu';

export default DetailsMenu;
